import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { pb } from "@/lib/pocketbase";
import { type AppointmentsResponse, Collections } from "@/types/pocketbase.ts";
import type { FullListOptions, ListOptions, OneOptions } from "@/types/query-options";

const COLLECTION = Collections.Appointments;

export const appointmentsQueries = {
	all: () => [COLLECTION],
	lists: () => [...appointmentsQueries.all(), "list"],
	list: <Texpand = unknown>(params: ListOptions = { page: 1, perPage: 10, options: {} }) =>
		queryOptions({
			queryKey: [
				...appointmentsQueries.lists(),
				{ page: params.page, perPage: params.perPage, options: params.options },
			],
			queryFn: () =>
				pb.collection(COLLECTION).getList<AppointmentsResponse<Texpand>>(params.page, params.perPage, params.options),
			placeholderData: keepPreviousData,
		}),
	fullLists: () => [...appointmentsQueries.lists(), "fullList"],
	fullList: <Texpand = unknown>(options?: FullListOptions) =>
		queryOptions({
			queryKey: [...appointmentsQueries.fullLists(), options ?? {}],
			queryFn: () =>
				pb.collection(COLLECTION).getFullList<AppointmentsResponse<Texpand>>({
					...options?.options,
					sort: options?.options?.sort ?? "-created",
				}),
			placeholderData: keepPreviousData,
		}),
	ones: () => [...appointmentsQueries.all(), "one"],
	one: <Texpand = unknown>(params?: OneOptions) =>
		queryOptions({
			queryKey: [...appointmentsQueries.ones(), params?.id, params?.options ?? {}],
			queryFn: () => pb.collection(COLLECTION).getOne<Texpand>(params?.id ?? "", params?.options),
			enabled: Boolean(params?.id),
		}),
};
